import React, { useState } from "react";
import './WebDesign.css';
import graphicdesign from './assets/graphicdesign.jpg';
import WebDevelopment from './assets/WebDevelopment.jpg'; // Add the About section image
import { CheckCircle } from 'lucide-react';

const coreservices = [
    {
        title: 'Logo design and brand assets',
        description: '– Custom logos and branding elements that define your identity.',
    },
    {
        title: 'Website graphics and visual elements',
        description: '– High-quality imagery and UI design for a seamless digital experience.',
    },
    {
        title: 'Marketing collateral (brochures, flyers, posters)',
        description: '– Professionally designed promotional materials to boost engagement.',
    },
    {
        title: 'Infographics and data visualization',
        description: '– Transforming complex information into visually compelling content.',
    },
];

const GraphicDesign = () => {
    return (
        <>
            {/* Banner Section */}
            <section className="webdesign-section">
                <div className="webdesign-overlay">
                    <div className="webdesign-content">
                        <h1 className="webdesign-title">Graphic Design</h1>
                        <p className="webdesign-breadcrumb">
                            <span>Dot LocalHost</span> &gt; <span>Graphic Design</span>
                        </p>
                    </div>
                </div>
            </section>

            <div className="company-section py-5">
                <div className="container">

                    <div className="row align-items-center">
                        {/* Left Text Column */}
                        <div className="col-md-6 text-column">
                            <h2>Graphic Design – Bringing Your Brand’s Vision to Life</h2>
                            <p>Effective graphic design is key to communicating your message visually and creating lasting impressions. At <b>Dot Localhost</b>, our Graphic Design services cover everything from logo creation to marketing materials, ensuring that your brand’s visual identity is both cohesive and impactful. Whether you need a new logo, website graphics, or promotional materials, we’ve got you covered.</p>
                            <p>In today’s fast-paced digital landscape, <b>strong visuals</b> play a crucial role in setting your brand apart from the competition. The right design not only grabs attention but also conveys trust, professionalism, and credibility. Our team of expert designers works closely with you to understand your brand’s unique identity and create designs that reflect your vision while appealing to your target audience.</p>
                            <p>We don’t just design logos—we create <b>comprehensive branding solutions</b> that ensure consistency across all touchpoints. From your website and social media presence to business cards and marketing materials, we make sure every visual element aligns with your brand identity. Our strategic approach helps businesses establish a <b>memorable presence</b>, fostering recognition and customer loyalty.</p>
                            <p>Additionally, we leverage the latest design trends and tools to craft <b>modern, sleek, and high-quality visuals</b> that leave a lasting impact. Whether you need a bold, eye-catching promotional flyer or a minimalist, elegant website layout, our team has the expertise to bring your ideas to life.</p>                            
                        </div>

                        {/* Right Image Column */}
                        <div className="col-md-6">
                            <img src={graphicdesign} alt="About Us" className="img-fluid about-image" />
                        </div>
                    </div>

                    <div className="row align-items-center mt-5">
                        <div className="col-md-6 text-column">
                            <img src={WebDevelopment} alt="About Us" className="img-fluid about-image" />
                        </div>
                        <div className="col-md-6 text-column">
                            <div className="p-8 bg-white rounded-2xl shadow-md max-w-4xl mx-auto text-column">
                                <h3 className="text-2xl font-bold mb-6">What we offer</h3>
                                <ul className="space-y-4">
                                    {coreservices.map((crservices, index) => (
                                        <li key={index} className="flex items-start">
                                            <CheckCircle className="text-green-500 w-6 h-6 mt-1 mr-3" />
                                            <div>
                                                <h4 className="text-lg font-semibold">{crservices.title}</h4>
                                                <p className="text-gray-700">{crservices.description}</p>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>

                    <section className="hero-section text-column mt-5">
                        <p>Let Dot Localhost handle your graphic design needs and elevate your brand’s visual appeal with stunning, high-quality designs!</p>
                    </section>

                </div>
            </div>
        </>
    );
};

export default GraphicDesign;